module.exports = __webpack_public_path__ + "img/top-function-search-hashtag.5d8b383c.jpg";